module.exports = __webpack_public_path__ + "static/media/Muli-ExtraBoldItalic.52d70b48.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli-ExtraBoldItalic.ttf
// module id = 3338
// module chunks = 70